
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import TruckTemplateModule from "@/store/modules/truckTemplate";

const truckTemplateModuleState = getModule(TruckTemplateModule);

@Component({
  components: {
    Select
  }
})
export default class TruckTemplateWeekdaysSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get options() {
    return truckTemplateModuleState.weekdays.map(x => ({ label: x.text, value: x.value }));
  }
}
